import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import './index.css'

export default function Copyright(props: any) {
    return (
        <div className="copyright-box">
            <Typography fontFamily='Poppins' variant="body2" color="text.secondary" align="center" {...props}>
                {'Copyright © '}
                <Link color="inherit" to="https://www.ledefyl.com.uy/" target="_blank">
                    Ledefyl
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        </div>
    );
}